import React from 'react'
import { Stack, Typography } from '@sureco/design-system'
import { createClasses } from 'design-system/helper'
import styles from 'design-system/button/Button.module.scss'
import { EnrollmentItemProps } from './types/enrollment-item.types'
import dayjs from 'dayjs'

export default function EnrollmentItem({
  config,
  customerId,
  downloadUrl,
  isLoadingDownloadUrls,
}: EnrollmentItemProps) {
  const isNextYearEnrollment =
    dayjs(config.benefitEffectiveDate).year() === dayjs().add(1, 'year').year()
  const isOnOrAfterEnrollmentEndDate = dayjs().isSameOrAfter(
    dayjs(config.enrollmentEndDate)
  )

  const getButtonText = () => {
    if (isLoadingDownloadUrls) return 'Loading...'
    if (downloadUrl) return 'Download Payroll Deduction File'
    return 'No Download Available'
  }

  return (
    <Stack>
      <Stack direction="row" space={10} align="center">
        <Typography bold size={14}>
          Open Enrollment Period:
        </Typography>
        <Typography size={14}>
          {config.enrollmentStartDate} - {config.enrollmentEndDate}
        </Typography>
      </Stack>
      <Stack direction="row" space={10} align="center">
        <Typography bold size={14}>
          Benefit Effective Date:
        </Typography>
        <Typography size={14}>{config.benefitEffectiveDate}</Typography>
      </Stack>
      <Stack direction="row" space={10} align="center">
        <Typography bold size={14}>
          Enrollment Effective Policy:
        </Typography>
        <Typography size={14}>
          {config.benefitEffectivePolicy} {config.benefitEffectivePolicyUnit}
        </Typography>
      </Stack>

      {customerId && isNextYearEnrollment && isOnOrAfterEnrollmentEndDate && (
        <Stack
          direction="row"
          space={10}
          align="center"
          style={{ marginTop: '16px' }}
        >
          <Typography bold size={14}>
            Payroll Deduction Download:
          </Typography>
          <a
            href={downloadUrl || '#'}
            download
            target="_blank"
            className={createClasses(
              styles.button,
              styles.large,
              downloadUrl ? styles['primary-flat'] : styles['secondary-flat'],
              !downloadUrl ? 'disabled' : ''
            )}
            style={{
              textDecoration: 'none',
              pointerEvents: downloadUrl ? 'auto' : 'none',
            }}
          >
            <span className={styles.buttonContent}>{getButtonText()}</span>
          </a>
        </Stack>
      )}
    </Stack>
  )
}
